import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import LogoAdele from "../../img/logo-adele.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Github from "@iconscout/react-unicons/icons/uil-github";
import { Link } from "react-scroll";

const footerLinks = [
  { to: "Accueil", label: "Accueil" },
  { to: "Services", label: "Services" },
  { to: "Expérience", label: "Expérience" },
  { to: "Portfolio", label: "Portfolio" },
  { to: "Contact", label: "Contact" },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <img src={Wave} alt="" className="footer-wave" />
      <div className="f-content container">
        <div className="f-brand">
          <div className="f-brand-row">
            <img src={LogoAdele} alt="Adele" className="f-logo" width="40" height="40" />
            <strong>Adèle Manga</strong>
          </div>
          <p>
            Développeuse fullstack — applications web modernes, performantes et
            soignées.
          </p>
        </div>

        <nav className="f-nav" aria-label="Navigation pied de page">
          {footerLinks.map((item) => (
            <Link
              key={item.to}
              spy
              smooth
              offset={-80}
              duration={500}
              to={item.to}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="f-contact">
          <a href="mailto:adelemanga75@gmail.com">adelemanga75@gmail.com</a>
          <div className="f-icons">
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <Insta color="white" size="2rem" />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <Facebook color="white" size="2rem" />
            </a>
            <a
              href="https://github.com/adelemanga"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <Github color="white" size="2rem" />
            </a>
          </div>
        </div>

        <div className="f-studio">
          <p className="f-studio-brand">Adèle Web Studio</p>
          <p className="f-studio-tagline">
            Sites codés sur mesure, e-commerce personnalisé, applications web et
            interfaces administrables.
          </p>
          <a
            className="f-studio-link"
            href="https://adelewebstudio.com"
            target="_blank"
            rel="noreferrer"
          >
            adelewebstudio.com
          </a>
        </div>

        <div className="f-bottom">
          <span>
            © {year} Adèle Manga —{" "}
            <a href="https://adelewebstudio.com" target="_blank" rel="noreferrer">
              Adèle Web Studio
            </a>
            . Tous droits réservés.
          </span>
          <Link
            className="f-top"
            spy
            smooth
            offset={-80}
            duration={500}
            to="Accueil"
          >
            Retour en haut
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
